import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useServiceCarStore } from '../../store/serviceCarStore';
import BookAserviceInfoModal from '../elements/bookAServiceInfoModal';

const CarInfoSection = ({ carData, hasDriver }) => {
  const navigate = useNavigate();

  const { setCarInfo } = useServiceCarStore();

  const { EndDate, BodyType, FuelType, ModelName, MakeName, plateno, Color, VIN, CreditFacilityCode } = carData;
  return (
    <div className="flex flex-col gap-6 py-3 px-6">
      <div className="flex justify-between">
        <h4>{MakeName}</h4>
        {!!hasDriver ? (
          <button
            type="button"
            className="btn-secondary text-secondary-button"
            onClick={() => {
              navigate('/service-booking');
              setCarInfo(carData);
            }}
          >
            Ραντεβού Service
          </button>
        ) : (
          <BookAserviceInfoModal />
        )}
      </div>
      <div className="flex flex-wrap gap-8">
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Τύπος Καυσίμου</span>
          <span className="body-text">{FuelType}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Τύπος Αυτοκινήτου</span>
          <span className="body-text">{BodyType}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Αριθμός Πινακίδας</span>
          <span className="body-text">{plateno}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Λήξη Συμβολαίου</span>
          <span className="body-text">{EndDate.split('-')[2] +'/'+ EndDate.split('-')[1] +'/'+ EndDate.split('-')[0]}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          Χρώμα
          </span>
          <div className="body-text">{Color}</div>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          VIN
          </span>
          <div className="body-text">{VIN}</div>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          Αριθμός παραρτήματος
          </span>
          <div className="body-text">{CreditFacilityCode}</div>
        </div>
      </div>
    </div>
  );
};

export default CarInfoSection;
